export default "__VITE_ASSET__04df66f1__"